<template>
  <div>
    <v-form v-model="formularioValido" ref="agregarMunicipios">
      <v-card>
        <v-card-title class="secondary--text">
          Registrar nuevo municipio
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-select
            v-model="municipio.idEntidad"
            label="Entidad"
            :items="entidades"
            item-text="nombre"
            item-value="id"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-select>
          <custom-text-field
            label="Nombre del Municipio"
            v-model="municipio.nombre"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-text-field>
          <custom-text-field
            label="Nombre Corto del Municipio"
            v-model="municipio.nombreCorto"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-text-field>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixAgregarMunicipio"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixCatalogoMunicipios from './mixCatalogoMunicipios';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'CatalogosMunicipiosNuevo',
  mixins: [mixCatalogoMunicipios],
  components: {
    CustomTextField,
    CustomSelect,
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      municipio: {
        idEntidad: '',
        nombre: '',
        nombreCorto: '',
      },
    };
  },

  methods: {
    cerrar() {
      this.limpiarformulario();
      this.$emit('cerrar');
    },
    limpiarformulario() {
      this.$refs.agregarMunicipios.reset();
    },
  },
};
</script>

<style>
</style>
